<div class="container-sm my-3">
    <div class="mt-5"></div>
    <div [formGroup]="formGroup" [@.disabled]="!isInsert()">
        <!-- POSTHUMOUS POLICY -->
        <div class="form-group row my-3" *ngIf="isNdgRetired">
            <label for="posthumousPolicy" class="col-4 col-form-label">{{ "survey.new.protection.posthumous-policy" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="posthumousPolicy" formControlName="posthumousPolicy">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(posthumousPolicy)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- DANGEROUS PROFESSION -->
        <div class="form-group row my-3">
            <label for="dangerousProfession" class="col-4 col-form-label">{{ "survey.new.protection.dangerous-profession" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="dangerousProfession" formControlName="dangerousProfession">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(dangerousProfession)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- SPORT -->
        <div class="form-group row my-3">
            <label for="sport" class="col-4 col-form-label">{{ "survey.new.protection.sport" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="sport" formControlName="sport">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.protection.sport." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(sport)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- PETS -->
        <div class="form-group row my-3">
            <label for="pets" class="col-4 col-form-label">{{ "survey.new.protection.pets" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="pets" formControlName="pets">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(pets)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- PETS PROTECTION -->
        <div class="form-group row my-3" *ngIf="pets?.value === 'Y'" [@fadeInOut]>
            <label for="petsProtection" class="col-4 col-form-label">{{ "survey.new.protection.pets-protection" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="petsProtection" formControlName="petsProtection">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.protection.pets." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(petsProtection)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- OTHER PROTECTION -->
        <div class="form-group row my-3">
            <label for="otherProtection" class="col-4 col-form-label">{{ "survey.new.protection.other-protection" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="otherProtection" formControlName="otherProtection">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(otherProtection)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- FAMILY PROTECTION -->
        <div class="form-group row my-3" *ngIf="otherProtection?.value === 'Y'" [@fadeInOut]>
            <label for="familyProtection" class="col-4 col-form-label">{{ "survey.new.protection.family-protection" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="familyProtection" formControlName="familyProtection">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(familyProtection)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- INJURIES -->
        <div class="form-group row my-3" *ngIf="otherProtection?.value === 'Y'" [@fadeInOut]>
            <label for="injuries" class="col-4 col-form-label">{{ "survey.new.protection.injuries" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="injuries" formControlName="injuries">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.protection.injuries." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(injuries)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- SELF SUFFICIENCY -->
        <div class="form-group row my-3">
            <label for="selfSufficiency" class="col-4 col-form-label">{{ "survey.new.protection.self-sufficiency" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="selfSufficiency" formControlName="selfSufficiency">
                    <option *ngFor="let key of ['A', 'B', 'C', 'D']" [value]="key">
                        {{ "survey.domain.protection.self-sufficiency." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(selfSufficiency)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- SSN -->
        <div class="form-group row my-3">
            <label for="ssn" class="col-4 col-form-label">{{ "survey.new.protection.ssn" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="ssn" formControlName="ssn">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(ssn)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- SSN FEES -->
        <div class="form-group row my-3" *ngIf="ssn?.value === 'Y'" [@fadeInOut]>
            <label for="ssnFees" class="col-4 col-form-label">{{ "survey.new.protection.ssn-fees" | translate }}</label>
            <div class="col-8">
                <input prefix="€ " mask="separator.0" thousandSeparator="." type="text" class="form-control" id="ssnFees" formControlName="ssnFees" [attr.disabled]="completed">
            </div>
        </div>

        <!-- HEALTH COVERAGES -->
        <div class="form-group row my-3">
            <label class="col-4 col-form-label">{{ "survey.new.protection.health-coverages" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D']" >
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(healthCoverages, $event)" [disabled]="completed" [checked]="healthCoverages?.value.includes(key)">
                            {{ "survey.domain.protection.health-coverages." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- FUNDING -->
        <div class="form-group row my-3">
            <label for="funding" class="col-4 col-form-label">{{ "survey.new.protection.funding" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="funding" formControlName="funding">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(funding)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- FUNDING AMOUNT -->
        <div class="form-group row my-3" *ngIf="funding?.value === 'Y'" [@fadeInOut]>
            <label for="fundingAmount" class="col-4 col-form-label">{{ "survey.new.protection.funding-amount" | translate }}</label>
            <div class="col-8">
                <input prefix="€ " mask="separator.0" thousandSeparator="." type="text" class="form-control" id="fundingAmount" formControlName="fundingAmount" [attr.disabled]="completed">
            </div>
        </div>

        <!-- FUNDING DUE DATE -->
        <div class="form-group row my-3" *ngIf="funding?.value === 'Y'" [@fadeInOut]>
            <label for="fundingDueDate" class="col-4 col-form-label">{{ "survey.new.protection.funding-due-date" | translate }}</label>
            <div class="col-8">
                <input ngbDatepicker class="form-control" placeholder="dd/mm/yyyy" id="fundingDueDate" formControlName="fundingDueDate" #d="ngbDatepicker" (click)="d.toggle()" readonly="true" />
                <mat-error *ngIf="hasError(fundingDueDate)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- MOVABLE PROPERTY -->
        <div class="form-group row my-3">
            <label for="movableProperty" class="col-4 col-form-label">{{ "survey.new.protection.movable-property" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="movableProperty" formControlName="movableProperty">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(movableProperty)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- PROPERTY -->
        <div class="form-group row my-3">
            <label for="property" class="col-4 col-form-label">{{ "survey.new.protection.property" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="property" formControlName="property">
                    <option *ngFor="let key of ['A', 'B']" [value]="key">
                        {{ "survey.domain.protection.property." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(property)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- PROPERTY PROTECTION -->
        <div class="form-group row my-3">
            <label for="propertyProtection" class="col-4 col-form-label">{{ "survey.new.protection.property-protection" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="propertyProtection" formControlName="propertyProtection">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.protection.property-protection." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(propertyProtection)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>
        
        <!-- PRIORITY GUARANTEES -->
        <div class="form-group row my-3" *ngIf="!!propertyProtection?.value && propertyProtection?.value !== 'A'" [@fadeInOut]>
            <label class="col-4 col-form-label">{{ "survey.new.protection.priority-guarantees" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']" >
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(priorityGuarantees, $event)" [disabled]="completed" [checked]="priorityGuarantees?.value.includes(key)">
                            {{ "survey.domain.protection.priority-guarantees." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- PROPERTY COVERAGES -->
        <div class="form-group row my-3" *ngIf="!!propertyProtection?.value && propertyProtection?.value !== 'A'" [@fadeInOut]>
            <label class="col-4 col-form-label">{{ "survey.new.protection.property-coverages" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D']" >
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(propertyCoverages, $event)" [disabled]="completed" [checked]="propertyCoverages?.value.includes(key)">
                            {{ "survey.domain.protection.property-coverages." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- B&B -->
        <div class="form-group row my-3">
            <label for="bnb" class="col-4 col-form-label">{{ "survey.new.protection.bnb" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="bnb" formControlName="bnb">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(bnb)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- INTERNET -->
        <div class="form-group row my-3">
            <label for="internet" class="col-4 col-form-label">{{ "survey.new.protection.internet" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="internet" formControlName="internet">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(internet)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- VEHICLE -->
        <div class="form-group row my-3">
            <label class="col-4 col-form-label">{{ "survey.new.protection.vehicle" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D']" >
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(vehicle, $event)" [disabled]="completed" [checked]="vehicle?.value.includes(key)">
                            {{ "survey.domain.protection.vehicle." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- ACTIVE COVERAGES -->
        <div class="form-group row my-3">
            <label class="col-4 col-form-label">{{ "survey.new.protection.active-coverages" | translate }}</label>
            <div class="col-8">
                <div class="row border rounded mx-1">
                    <div class="col-6" *ngFor="let key of ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S']" >
                        <mat-checkbox [value]="key" color="primary" (change)="onCheckChange(activeCoverages, $event)" [disabled]="completed" [checked]="activeCoverages?.value.includes(key)">
                            {{ "survey.domain.protection.active-coverages." + key | translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- COVERAGE AMOUNT -->
        <div class="form-group row my-3" *ngIf="activeCoverages?.value.indexOf('C') !== -1" [@fadeInOut]>
            <label for="coverageAmount" class="col-4 col-form-label">{{ "survey.new.protection.coverage-amount" | translate }}</label>
            <div class="col-8">
                <input prefix="€ " mask="separator.0" thousandSeparator="." type="text" class="form-control" id="coverageAmount" formControlName="coverageAmount" [attr.disabled]="completed">
            </div>
        </div>

        <!-- COVERAGE ALTERNATIVE -->
        <div class="form-group row my-3">
            <label for="coverageAlternative" class="col-4 col-form-label">{{ "survey.new.protection.coverage-alternative" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="coverageAlternative" formControlName="coverageAlternative">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(coverageAlternative)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- COVERAGE DURATION -->
        <div class="form-group row my-3">
            <label for="coverageDuration" class="col-4 col-form-label">{{ "survey.new.protection.coverage-duration" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="coverageDuration" formControlName="coverageDuration">
                    <option *ngFor="let key of ['B', 'C', 'D']" [value]="key">
                        {{ "survey.domain.protection.coverage-duration." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(coverageDuration)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- TEMPORARY SOLUTIONS -->
        <div class="form-group row my-3">
            <label for="temporarySolutions" class="col-4 col-form-label">{{ "survey.new.protection.temporary-solutions" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="temporarySolutions" formControlName="temporarySolutions">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(temporarySolutions)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- COVERAGE TRIVIA -->
        <div class="form-group row my-3">
            <label for="coverageTrivia" class="col-4 col-form-label">{{ "survey.new.protection.coverage-trivia" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="coverageTrivia" formControlName="coverageTrivia">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(coverageTrivia)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <div class="text-secondary fst-italic mt-3">{{ "survey.new.protection.hint" | translate }}</div>
        
        <!-- SUBMIT -->
        <button *ngIf="isInsert()" class="btn btn-primary mt-5 next-step" [disabled]="completed" (click)="onSubmit()">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            {{ "survey.new.protection.next" | translate }}
        </button>
    </div>
</div>
